import { Layout, Button, Dropdown, Avatar, Space } from 'antd'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import { useMerchantStore } from '../../stores/merchantStore'
import type { ReactNode } from 'react'

const { Header: AntHeader } = Layout

interface HeaderProps {
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
  announcementHeader?: ReactNode
}

export default function Header({ collapsed, setCollapsed, announcementHeader }: HeaderProps) {
  const navigate = useNavigate()
  const { logout, merchant: authMerchant } = useAuthStore((state) => ({ logout: state.logout, merchant: state.merchant }))
  const merchant = useMerchantStore((state) => state.merchant)

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  const dropdownItems = [
    {
      key: 'settings',
      icon: <UserOutlined />,
      label: '賬戶設定',
      onClick: () => navigate('/dashboard/settings'),
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登入',
      onClick: handleLogout,
    },
  ]

  return (
    <AntHeader className="dashboard-header">
      <Button
        type="text"
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        onClick={() => setCollapsed(!collapsed)}
        className="header-toggle-btn"
      />
      <Space size={12} className="header-actions">
        {announcementHeader}
        <Dropdown menu={{ items: dropdownItems }} placement="bottomRight">
          <Space className="header-user">
            <Avatar icon={<UserOutlined />} src={merchant?.logo} className="header-avatar" />
            <span className="header-username">{merchant?.name || merchant?.email || authMerchant?.name || authMerchant?.email || '商戶'}</span>
          </Space>
        </Dropdown>
      </Space>
    </AntHeader>
  )
}
